module.exports = __webpack_public_path__ + "static/img/game-bac.544a34bc.png";